export const setToken = token => {
  localStorage.setItem("token", token);
};

export const getAuthorizationHeader = () => {
  const token = localStorage.getItem("token");
  if (!token) {
    return {};
  }
  return {
    Authorization: `Bearer ${token}`
  };
};
